export const ROLES = {
    ADMIN: 'admin',
    MEMBER: 'member',
    FREE: 'free',
}

export const ACTIONS = {
    MANAGE: 'manage',
    CREATE: 'create',
    READ: 'read',
    UPDATE: 'update',
    DELETE: 'delete',
}

export const SUBJECT = {
    ALL: 'all',
    AUTH: 'auth',
    MANAGEMENT: 'management',
    NON_AUTH: 'non-auth',
    COMPASS: 'compass',
    MASTERCHART: 'masterchart',
    PASSPORT: 'passport',
    FORTUNE: 'fortune',
    FREE: 'free',
}

export const USER_TYPE = {
    ALL: 'all',
    MANAGEMENT: 'management',
    KAISEKISHI: 'kaiseki',
    KOZA: 'koza',
    NINTEI: 'nintei',
    FREE: 'free',
}

export const USER_PERMISSION = [
    '管理者',
    'NE運命解析学', // もともとはNE運命解析士
    '講座用',
    'NE運命解析士', // もともとはNE運命解析士認定講座用
]
